const config = {
    APP_NAME: 'Krisol Ticket System',
    API_BASE_URL: 'https://krisolticketapi.krisolinfosoft.com/api',
    TICKET_STATUSES: ['NEW', 'OPEN', 'PENDING', 'RESOLVED'],
    TICKET_TYPES: ['General Inquiry', 'Bug', 'Feature Request', 'Support'],
    companies: [
        { id: 1, name: 'Comart One Pre Media  Pvt Ltd' },
        { id: 2, name: 'Commerical  Repograprhers' },
        { id: 3, name: 'Comart Lithographers Pvt Ltd' },
        { id: 4, name: 'PhotoTechiks ' },
        // Add more companies as needed
    ],
    GOOGLE_CLIENT_ID : '671866369863-gi5k0ula75it1njl861ovcroo1pgh6hv.apps.googleusercontent.com',
    SHOW_ATTENDANCE : 'true',
};

export default config;

